module.exports = __webpack_public_path__ + "static/webmasters-stackexchange-a3845265a9b161e5336411b147c725e2.svg";